export default "__VITE_ASSET__BaQQUWGO__"